import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {GhostComponent} from '../../utils/ghostComponent';
import { ReservationDuration } from '../../domain/reservation/reservation';

@Component({
    selector: 'reservation-choice',
    templateUrl: './reservationChoice.component.html',
    styleUrls: ['./reservationChoice.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ReservationChoiceComponent),
            multi: true
        }
    ]
})
export class ReservationChoiceComponent extends GhostComponent implements ControlValueAccessor {
    @Input() public disabled: boolean;
    @Input() public reservationDurations: ReservationDuration[];
    @Output() public clickAction = new EventEmitter<{ actionName: string, reservationDuration: ReservationDuration }>();
    private reservationDuration: ReservationDuration;
    private onChange: (_: ReservationDuration) => void;
    private onTouched: () => void;

    isSelected(reservationDuration: ReservationDuration): boolean {
        return this.reservationDuration === reservationDuration;
    }

    selectReservationDuration(reservationDuration: ReservationDuration) {
        this.reservationDuration = reservationDuration;
        this.onTouched();
        this.onChange(this.reservationDuration);
    }

    generateGhost(): void {
    }

    public registerOnChange(onChange: (_: ReservationDuration) => void): void {
        this.onChange = onChange;
    }

    public registerOnTouched(onTouched: () => void): void {
        this.onTouched = onTouched;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    public writeValue(value: ReservationDuration): void {
        this.reservationDuration = value;
    }

    trackByDuration(index: number, reservationDuration: ReservationDuration) {
        return reservationDuration.durationInMinutes;
    }
}
